import { render, staticRenderFns } from "./group_edit.vue?vue&type=template&id=d28e1564&scoped=true&"
import script from "./group_edit.vue?vue&type=script&lang=js&"
export * from "./group_edit.vue?vue&type=script&lang=js&"
import style0 from "./group_edit.vue?vue&type=style&index=0&id=d28e1564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28e1564",
  null
  
)

export default component.exports